module.exports = "https://static.energy5.com/_next/static/images/deviceMobile-418992fe0f6b65188d65bdb350b253ec.png";